import { useMemo } from 'react';

import { PermissionType } from 'api/types/entity';
import { useTranslation } from 'libs/i18n';
import { usePermissions } from 'libs/permissions';
import { Input } from 'libs/ui';
import { TraderAutocompleteFeature } from 'modules/operation/common/features';
import { useFormContext } from 'modules/operation/common/forms/operationForm';

export const TraderField = () => {
  const { t } = useTranslation();
  const { checkPermissions } = usePermissions();

  const { values, readOnly } = useFormContext();

  const editable = !readOnly;

  const isAccess = useMemo(
    () =>
      checkPermissions(
        [
          PermissionType.Operation_CreateOneViaList,
          PermissionType.Operation_CreateOneViaOrder,
        ],
        'or'
      ),
    [checkPermissions]
  );

  if (!isAccess || !editable) {
    return (
      <Input
        fullWidth
        readOnly
        showCopyButton
        disabled={editable}
        label={t(
          'operation.sections.mainInformationSection.fields.trader.label'
        )}
        value={values.trader?.label}
      />
    );
  }

  return <TraderAutocompleteFeature />;
};
